import { render, staticRenderFns } from "./PrkDidacticMethodsContent.vue?vue&type=template&id=6bfff258&scoped=true&"
import script from "./PrkDidacticMethodsContent.vue?vue&type=script&lang=js&"
export * from "./PrkDidacticMethodsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfff258",
  null
  
)

export default component.exports